import React, { useCallback, useContext, useEffect, useState } from "react";
import Loginslider from "../Loginslider";
import { Link } from "react-router-dom";
import { useDataContext } from "../../../../Services/Context-Api/Context";
import { TostMsg } from "../../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function UserNotexit() {
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const { apiData } = useDataContext();
  const toster = useContext(TostMsg);
  const [signUp_message, setsignUp_message] = useState("");
    const [signUp_button, setSignUp_button] = useState("");
  const [signUp_URL, setsignUp_URL] = useState("");
  const [org_Unavailable, setOrg_Unavailable] = useState("");
  const [no_Record, setNo_Record] = useState("");
  const [no_Record_Header, setNo_Record_Header] = useState("");
  const [record_PrimaryButton, setRecord_PrimaryButton] = useState("");
  const [record_NewOrganization, setRecord_NewOrganization] = useState("");
  const [record_SecondaryButton, setRecord_SecondaryButton] = useState("");
  const [record_Option, setRecord_Option] = useState("");
  const [record_ExisitngOrganizartion, setRecord_ExisitngOrganizartion] = useState("");
  let history = useHistory();

  useEffect(() => {
    GetMasterSystemAlertList("signUp_message", 1);
    GetMasterSystemAlertList("signUp_button", 2);
    GetMasterSystemAlertList("SignUp_URL", 3);
    GetMasterSystemAlertList("Org_Unavailable", 4);
    GetMasterSystemAlertList("No_Record", 5);
    GetMasterSystemAlertList("Login_No_Record_Header", 6);
    GetMasterSystemAlertList("Login_No_Record_PrimaryButton", 7);
    GetMasterSystemAlertList("Login_No_Record_NewOrganization", 8);
    GetMasterSystemAlertList("Login_No_Record_SecondaryButton", 9);
    GetMasterSystemAlertList("Login_No_Record_Option", 10);
    GetMasterSystemAlertList("Login_No_Record_ExisitngOrganizartion", 11);

  }, []);

  if (!apiData) {
    history.push("/");
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setsignUp_message(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSignUp_button(msg?.Desc);
      } else if (msg?.Name == message && type == 3) {
        setsignUp_URL(msg?.Desc);
      } else if (msg?.Name == message && type == 4) {
        setOrg_Unavailable(msg?.Desc);
      } else if (msg?.Name == message && type == 5) {
        setNo_Record(msg?.Desc);
      } else if (msg?.Name == message && type == 6) {
        setNo_Record_Header(msg?.Desc);
      } else if (msg?.Name == message && type == 7) {
        setRecord_PrimaryButton(msg?.Desc);
      } else if (msg?.Name == message && type == 8) {
        setRecord_NewOrganization(msg?.Desc);
      } else if (msg?.Name == message && type == 9) {
        setRecord_SecondaryButton(msg?.Desc);
      } else if (msg?.Name == message && type == 10) {
        setRecord_Option(msg?.Desc);
      } else if (msg?.Name == message && type == 11) {
        setRecord_ExisitngOrganizartion(msg?.Desc);
      }

    });
  }, []);

  return (
    <section className="fxt-template-animation fxt-template-layout29 loaded">
       <div className="login-org-logo-area">
               <div className="container">
            <a className="fxt-logo">
                    <img
                      src="images/login/logo.png"
                      alt="Logo"
                      className="logo-login"
                    />
                  </a>
        </div>
          </div>
           <img src="images/login/right.png" className="leftpic" />
                <img src="  images/login/left.png" className="rightpic" />
                <div className="login-org-area">
      <div className="container">
        <div className="row align-items-center">
           <div className="col-lg-6 col-md-6">
            <div className="fxt-content">
              <img src="images/login/left.png" className="leftpic" />
              <img src="images/login/right.png" className="rightpic" />
              <div className="fxt-form mb-0">
                <div className="fxt-transformY-50 fxt-transition-delay-1">
                  <h2>Sorry !</h2>
                </div>
                <div className="fxt-transformY-50 fxt-transition-delay-2">
                  {apiData?.statusCode === 400 && (
                    <p className="not-reg">
                      The email <span> {apiData?.userName} </span> isn’t
                      registered with OrgGenie.{" "}
                      <Link to="/">
                        Click here
                        <img src="/images/tickets/edit-ico.svg" />
                      </Link>
                      to retry with a valid email.
                    </p>
                  )}
                  {apiData?.statusCode === 404 && (
                    <p className="not-reg">
                      <span> {org_Unavailable} </span>
                    </p>
                  )}
                  {apiData?.statusCode === 2002 && (
                    <>
                      <p className="not-reg">
                        <p className="not-reg">
                          {no_Record_Header} <span> <Link to="/">
                            {apiData?.userName}
                            <img src="/images/tickets/edit-ico.svg" />
                          </Link>  </span>
                        </p>
                      </p>
                      <form name="POST" style={{ marginTop: 20 }}>
                        <div className="">
                          <div className="fxt-transformY-50 fxt-transition-delay-6">
                            <div className="fxt-content-between">
                              <Link to="/" className="fxt-btn-fill text-center">
                                {record_PrimaryButton}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </form>
                     <div className="stuck-condition">
                           <h5 className="mt-3">{record_Option}</h5>
                          <ul className="list-login-bx">
                            <li>{record_ExisitngOrganizartion}</li>
                            <li>{record_NewOrganization}</li>
                          </ul>
                     </div>
                     <div className="invalid-bottom-text">
                         <h4><a href={signUp_URL} target="_blank"> {signUp_button}</a></h4>
                     </div>

                    </>
                  )}
                </div>
                {apiData?.statusCode === 400 && (
                  <form name="POST" style={{ marginTop: 20 }}>
                    <div className="form-group">
                      <div className="fxt-transformY-50 fxt-transition-delay-6">
                        <div className="fxt-content-between">
                          <a
                            href={signUp_URL}
                            className="fxt-btn-fill text-center"
                            target="_blank"
                          >
                            {signUp_message}
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
          <div className="vegas-container col-lg-6 col-md-6">
            <div className="">
                  <img src="/images/login/signup.svg" className="img-fluid"/>
                </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
}
